export default {
  loading: 'Yükleniyor...',
  categories: {
    basic: 'Temel',
    object: 'Nesneler',
    symbol: 'Semboller',
    arrow: 'Oklar',
    flowchart: 'Akış Şemaları',
    animal: 'Hayvanlar',
    game: 'Kartlar & Satranç',
    dialog_balloon: 'Diyalog baloncukları',
    electronics: 'Elektronikler',
    math: 'Matematikseller',
    music: 'Müzik',
    misc: 'Diğerleri',
    raphael_1: 'raphaeljs.com set 1',
    raphael_2: 'raphaeljs.com set 2'
  },
  buttons: [
    {
      title: 'Şekil kütüphanesi'
    }
  ]
}
